/** Canonical department labels (must match CreateUser / POSITION_OPTIONS keys). */
export const DEPARTMENT_CANONICAL = {
  SOFTWARE: "Software",
  MARKETING: "Marketing",
  CEO: "CEO",
  COO: "COO",
  HR: "HR",
  OTHER: "Other",
};

export function normalizeDepartmentKey(value) {
  return String(value || "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[/-]/g, "_")
    .toUpperCase();
}

/** Maps API / token values (e.g. MARKETING, software) to canonical department names. */
export function normalizeDepartment(value) {
  if (!value) return "";
  const key = normalizeDepartmentKey(value);
  return DEPARTMENT_CANONICAL[key] || String(value).trim();
}

export const POSITION_OPTIONS = {
  Software: ["Frontend Developer", "Backend Developer", "UI/UX Designer"],
  Marketing: [
    "SEO Specialist",
    "Content Creator",
    "Graphic Designer",
    "Media Production",
    "Moderator",
    "Social Media Specialist",
    "Ads Advertising",
    "Media Buyer",
    "Art Director",
  ],
  HR: ["HR"],
  Other: ["Legal Affairs", "Accountant", "Secretary", "Office Boy"],
  CEO: ["CEO"],
  COO: ["COO"],
};
